function getSelectedPickupLocation() {
    return document.querySelector('input[name="locations_select"]:checked');
}

const registerPickupSelectBtnClick = () => {
    const btn = document.querySelector('.select-pickup-button.btn')

    btn.onclick = async () => {
        const cart = await window.cartService.read()
        const locationRadio = CartPickupModal.getSelectedPickupLocation()

        if (!locationRadio) {
            console.warn('No pickup location selected');
            window.CartPickupModal.close()
            return null;
        }

        const matchedItem = cart.items.find(item => item.variant_id === CartPickupModal.currentItemId);
        if (!matchedItem) {
            return;
        }
        const locationName = locationRadio.value
        const pickupID = locationRadio.dataset.pickupid

        CartPickupModal.showModalLoader();

        try {
            const updatedCart = await window.CartShipping.setPickupMethod(matchedItem, locationName, pickupID);
            if (updatedCart) {
                window.CartShipping.updatePickupUI(CartPickupModal.currentItemId, locationName, true)
                window.CartShipping.updateDeliveryOptionsUi(CartPickupModal.currentItemId)

                window.CartShipping.updatePickupLocationUI(
                    matchedItem.variant_id.toString(),
                    locationName,
                    locationRadio.dataset.distance,
                    locationRadio.dataset.units,
                    pickupID.toString()
                );
                window.CartPickupModal.close()
            }
        } catch (error) {
            console.error('[CartPickupModal] Error setting pickup method:', error);
            curacaoLogger && curacaoLogger.log('ERROR', '[CartPickupModal] Failed to set pickup method', error);
        } finally {
            CartPickupModal.hideModalLoader();
        }
    }
}

const registerOpenButtonsClick = () => {
    const $openModalButtons = $('.edit_location_btn')
    $openModalButtons.on('click', function () {

        const button = this;
        const $button = $(button)

        const variantID = +button.dataset.itemid

        if (!variantID || isNaN(variantID)) {
            console.error('Invalid variant ID:', button.dataset.itemid);
            return;
        }


        window.CartPickupModal.$currentOpenButton = $button
        window.CartPickupModal.currentItemId = variantID

        CartPickupModal.showLoader()

        void getProductInventory(variantID, $button);
    })
}

function renderPickupLocationItem(location, i, dayName, currentPickupId) {
    const storehours = location.metafields.filter((node) => node.key == "custom.hours");
    const pickup_id = location.pickupId

    if (!pickup_id) return '';

    let hoursHtml = '';
    if (storehours[0] !== undefined) {
        const schedule = storehours[0].value.split(',');
        hoursHtml = schedule.map(sched => {
            const day = sched.split(':')[0].trim();
            return `<p class='day${(dayName === day ? " active" : "")}' data-day='${day}'>${sched}</p>`;
        }).join('');
    } else {
        hoursHtml = "<p class='day'>WORKING HOURS - not updated</p>";
    }

    let mapEmbed = '';
    location.metafields.forEach(node => {
        if (node.key == "custom.map_embedded_code") {
            mapEmbed = `<div class="map_embad_code filled">${node.value}</div>`;
        }
    });


    return `
    <li class="pickup-availability-list__item">
      <div class="select-box-radio">
        <input
          type="radio"
          name="locations_select"
          value="${location.name}"
          data-distance="${location.distanceText}"
          data-units="${location.quantity}"
          data-lat="${location.latitude}"
          data-pickupid="${pickup_id}"
          data-long="${location.longitude}"
          data-zip="${location.zip}"
          id="location_select_${i}"
          ${currentPickupId === pickup_id ? "checked" : ""}
        />
      </div>
      <div class="location-details-cover">
        <h3 class="h4">${location.name} | ${location.distanceText}</h3>
        <p class="pickup-availability-preview caption-large">
          <svg
            class="icon icon-tick" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg"
            fill="none" viewBox="0 0 20 20"
          >
            <path
              fill="#108043" stroke="#fff"
              d="M16.136 6.979h0l.003-.004a1.499 1.499 0 00-2.275-1.954l-5.945 6.777-1.858-1.859A1.499 1.499 0 103.94 12.06l2.999 3s0 0 0 0c.289.29.675.44 1.1.439h.019a1.5 1.5 0 001.08-.522l6.998-7.998z"
            ></path>
          </svg>
          Pickup available, usually ready in 24 hours
        </p>
        <address class="pickup-availability-address">
          <p>${location.address1}<br />${location.name} ${location.provinceCode} ${location.zip}</p>
          <p>${location.phone}</p>
        </address>
        <p>${location.quantity} units available at this store</p>
        <div class="show_store_details">Store details</div>
        <div class="store_details">
          ${mapEmbed}
          <div class="store_hours">${hoursHtml}</div>
        </div>
      </div>
    </li>
  `.trim();
}

function mapLocationInfo(location, storeLocations) {
    const pickupId = location.node.location.metafields.nodes.find((node) => node.key === 'custom.pickup_id')?.value
    const storeLocationInfo = storeLocations?.find((storeLocation) => {
        return storeLocation.storeCode === pickupId
    })

    const miles = storeLocationInfo?.distance || null

    return {
        id: location.node.location.id,
        pickupId,
        name: location.node.location.name,
        address1: location.node.location.address.address1,
        address2: location.node.location.address.address2,
        city: location.node.location.address.city,
        country: location.node.location.address.country,
        country_code: location.node.location.address.countryCode,
        latitude: location.node.location.address.latitude,
        longitude: location.node.location.address.longitude,
        province: location.node.location.address.province,
        provinceCode: location.node.location.address.provinceCode,
        zip: location.node.location.address.zip,
        phone: location.node.location.address.phone,
        metafields: location.node.location.metafields.nodes,
        distance: miles,
        distanceText: miles ? `${miles} mile` : '',
        durationText: null,
        quantity: location.node.quantities[0].quantity
    }
}

async function getProductInventory(variantID, $elm) {
    const inventoryUrl = `${window.GLOBAL_LARAVEL_API}/api/v1/shopify/get-inventory-levels?variantID=${variantID}`

    try {
        let zipCode
        if (typeof tryGetCustomerZipCode !== 'undefined') {
            zipCode = tryGetCustomerZipCode()
        }
        const promises = [];

        if (Boolean(zipCode)) {
            const storeAvailabilityPromise = storeAvailabilityService.getAvailability({
                zipcode: zipCode,
                items: [
                    {
                        itemId: $elm.data('itemid').toString(),
                        sku: $elm.data('sku'),
                        isSet: $elm.data('is_set') || false
                    }
                ]
            })
            promises.push(storeAvailabilityPromise);
        }

        const inventoryPromise = fetch(inventoryUrl);
        promises.push(inventoryPromise);

        const results = await Promise.allSettled(promises);

        const storeAvailabilityIndex = Boolean(zipCode) ? 0 : -1;
        const inventoryIndex = Boolean(zipCode) ? 1 : 0;

        let storeLocations = [];
        if (storeAvailabilityIndex >= 0) {
            const storeAvailabilityResult = results[storeAvailabilityIndex];
            if (storeAvailabilityResult.status === 'fulfilled' && storeAvailabilityResult.value.list) {
                try {
                    storeLocations = storeAvailabilityResult.value.list?.[0]?.STORES || [];
                } catch (error) {
                    console.warn('Failed to parse store availability response:', error);
                }
            } else {
                console.warn('Store availability request failed, using fallback (empty array)');
            }
        }

        const inventoryResult = results[inventoryIndex];
        if (inventoryResult.status === 'rejected' || !inventoryResult.value.ok) {
            throw new Error(`Inventory levels HTTP error! Status: ${inventoryResult.value?.status || 'failed'}`);
        }

        const inventoryData = await inventoryResult.value.json();
        const locations = inventoryData?.data?.productVariant?.inventoryItem?.inventoryLevels?.edges || [];

        CartPickupModal.hideLoader()
        const cart = await window.cartService.read()
        var items = cart.items
        const currentItem = items.find((item) => item.id === variantID)

        const availableLocations = locations
            .filter((location) => {
                const stockQty = location.node.quantities[0].quantity
                return stockQty > 0
                    && stockQty >= currentItem.quantity
                    && location.node.location.metafields.nodes.some((node) => node.key == 'custom.pickup_instore' && node.value == 'true')
            })

        if (!availableLocations.length) {
            var productItem = $elm.closest(CartSelectors.cart.lineItemExtraDetails())[0];

            window.CartShipping.handlePickupUnavailable(productItem, currentItem);

            return false;
        }

        const locations_data = availableLocations
            .map((location) => mapLocationInfo(location, storeLocations))
            .filter((loc) => loc.distance <= 50)
            .sort((a, b) => a.distance - b.distance);

        let currentDate = new Date();
        let dayOfWeek = currentDate.getDay();
        const daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
        const dayName = daysOfWeek[dayOfWeek];

        const currentPickupId = window.CartPickupModal.getSelectedPickupId()
        document.querySelector('#location-pickup-popup .pickup-availability-list').innerHTML = locations_data
            .slice(0, 3)
            .map((location, i) => renderPickupLocationItem(location, i, dayName, currentPickupId))
            .join('');

        window.CartPickupModal.open()
    } catch (error) {
        console.error(error)
        CartPickupModal.hideLoader()
    }
}


window.CartPickupModal = {
    hideLoader: function () {
        this.$currentOpenButton.find('.laber-loading').addClass('hide');
    },
    showLoader: function () {
        this.$currentOpenButton.find('.laber-loading').removeClass('hide');
    },

    showModalLoader: function () {
        const modalContent = document.querySelector('#location-pickup-popup .popup-content');
        if (modalContent) {
            modalContent.classList.add('is-loading');
        }
    },

    hideModalLoader: function () {
        const modalContent = document.querySelector('#location-pickup-popup .popup-content');
        if (modalContent) {
            modalContent.classList.remove('is-loading');
        }
    },

    open: function () {
        this.$currentOpenButton[0].parentNode.nextElementSibling.click()
        this.hideLoader()
        this.hideModalLoader()
    },
    close: function () {
        this.hideModalLoader()
        document.querySelector('#location-pickup-popup .mfp-close').click()
    },
    isLoading: false,

    $currentOpenButton: null,
    currentItemId: null,

    getSelectedPickupLocation,
    
    mapLocationInfo,

    getSelectedPickupId: function () {
        const currenPickupOption = this.$currentOpenButton[0]
            .parentNode
            .parentNode
            .querySelector('.ship-option')

        if (currenPickupOption?.checked) {
            return currenPickupOption.dataset.pickupid
        }

        return null
    },

    init() {
        this.bindEvents();
    },

    bindEvents() {
        registerPickupSelectBtnClick()
        registerOpenButtonsClick()
    }
}
